var version = {
    "name":      "dativery",
    "buildDateCode": "20251208-175137",
    "buildDate": "Mon Dec 08 2025 17:51:37 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251208-175137",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;